import * as R from 'ramda';

export function mergeFilters<T extends { [k: string]: unknown }>(prev: T, next: Partial<T>): Partial<T> {
  return R.filter((x) => x != null && (!Array.isArray(x) || !!x.length), R.mergeAll([prev, next]));
}
